import { itemsService } from '../services'

export default (formData) => {
	return new Promise(resolve => {
		itemsService.updateRisk(formData)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
